
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 25 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M16.5 8c0 2.21-1.79 4-4 4s-4-1.79-4-4l.11-.94L5.5 5.5l7-3.5 7 3.5v5h-1V6l-2.11 1.06.11.94zm-4 6c4.42 0 8 1.79 8 4v2h-16v-2c0-2.21 3.58-4 8-4z"}})])
          )
        }
      }
    